import makeQueryKey from "../../../../utils/make-query-key";
var getTranslationsQueryKey = function getTranslationsQueryKey(_ref) {
  var language = _ref.language;
  return makeQueryKey(['i18n/dotcom-cart', language]);
};
export default getTranslationsQueryKey;